module.exports = __webpack_public_path__ + "img/unlock.3ce19840.svg";